(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["emeltec-product-docs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const tab = event.target.closest('.emeltec-docs__tab');
    if (tab) selectTab(tab);
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('.emeltec-docs__tab');
    if (!tab || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
    const tabs = [...tab.parentElement.querySelectorAll('.emeltec-docs__tab')];
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];
    next.focus();
    selectTab(next);
  });

  function selectTab(selected) {
    const root = selected.closest('[data-emeltec-docs]');
    root.querySelectorAll('.emeltec-docs__tab').forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', active);
      tab.tabIndex = active ? 0 : -1;
      const panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
      panel.hidden = !active;
      const frame = panel.querySelector('iframe[data-src]');
      if (active && frame && !frame.src) frame.src = frame.dataset.src;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["emeltec-product-meta"] && !Shopify.designMode) return;
  try {
    /*
   * Products grouped by variants ("Modelo" buttons): the theme only refreshes its own blocks when
   * the variant changes, so the Emeltec price, facts and buy / quote blocks (marked data-emeltec-live)
   * are refreshed here from the same server-rendered section the variant picker has just requested
   * (the theme's own product-select event), so it also works when the chosen combination has no variant.
   *
   * The buy / quote block (data-emeltec-sale-mode, rendered by blocks/buy-buttons.liquid from live
   * inventory and price) is swapped when the mode changes, or when a quote button must point at another
   * variant. A variant that is bought keeps the theme's own form, which already follows the variant.
   */
  import('@shopify/events')
    .then(({ StandardEvents }) => {
      document.addEventListener(StandardEvents.productSelect, (event) => {
        const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
        if (!picker || picker.dataset.templateProductMatch !== 'true') return;
        if (picker.closest('product-card, quick-add-dialog')) return;

        Promise.resolve(event.promise)
          .then(({ detail }) => {
            const fresh = detail && detail.html;
            if (!fresh || typeof fresh.querySelector !== 'function') return;
            document.querySelectorAll('[data-emeltec-live]').forEach((current) => {
              const next = fresh.querySelector(`[data-emeltec-live="${current.dataset.emeltecLive}"]`);
              if (!next) return;
              if ('emeltecSaleMode' in current.dataset) {
                const sameMode = current.dataset.emeltecSaleMode === next.dataset.emeltecSaleMode;
                const sameVariant = current.dataset.emeltecVariant === next.dataset.emeltecVariant;
                if (sameMode && (next.dataset.emeltecSaleMode === 'buy' || sameVariant)) return;
              }
              current.replaceWith(next);
            });
          })
          .catch((error) => {
            if (error && error.name !== 'AbortError') console.error('Emeltec: no se pudo actualizar la variante', error);
          });
      });
    })
    .catch((error) => console.error('Emeltec: no se pudo escuchar el cambio de variante', error));
  } catch(e) { console.error(e); }
})();

})();
